import api from "../api/axiosInstance";

export const cartTrackingMiddleware = store => next => action => {

    const isMetaTraffic = () => {
        if (typeof window === 'undefined') return false;

        if (document.cookie.includes('_fbc=')) return true;

        const params = new URLSearchParams(window.location.search);
        return params.has('fbclid');
    };

    const result = next(action);
    if (action.type === 'cart/addItem') {
        const product = action.payload;

        let source = product.source ?? 'queetstonepage';
        const quantity = product.quantity ?? 1;

        if (isMetaTraffic() && source !== 'Direct') {
            source = 'metaAd';
        }

        if (window.fbq) {
            window.fbq('track', 'AddToCart', {
                content_ids: [product.sku],
                content_name: product.title,
                content_type: 'product',
                quantity,
            });
        }

        api.post('/orders/add-to-cart', {
            productId: product._id,
            title: product.title,
            sku: product.sku,
            quantity,
            source,
        }).catch(err => console.error('Failed to log Add-to-Cart:', err));

    }

    return result;
};